// src/context/AppStateContext.js
import React, { createContext, useContext, useState } from 'react';

const AppStateContext = createContext();

export const AppStateProvider = ({ children }) => {
  const [selectedStop, setSelectedStop] = useState(null);
  const [stopTimes, setStopsTimes] = useState(null);
  const [trips, setTrips] = useState(null);
  const [routes, setRoutes] = useState(null);
  const [shapes, setShapes] = useState(null);
  const [stops, setStops] = useState(null);
  const [frequencies, setFrequencies] = useState(null);

  const value = {
    selectedStop,
    setSelectedStop,
    stopTimes,
    setStopsTimes,
    trips,
    setTrips,
    routes,
    setRoutes,
    shapes,
    setShapes,
    stops,
    setStops,
    frequencies,
    setFrequencies
    // add more shared states here
  };

  return (
    <AppStateContext.Provider value={value}>
      {children}
    </AppStateContext.Provider>
  );
};

export const useAppState = () => useContext(AppStateContext);
